<template>
	<div class="toggle-icon" @click="toggle">
		<Transition name="fade">
			<span v-if="!modelValue" class="material-symbols-rounded">add</span>
		</Transition>
	
		<Transition name="fade">
			<span v-if="modelValue" class="material-symbols-rounded">remove</span>
		</Transition>
	</div>
</template>

<script>
	export default {
		name: 'ToggleIcon',
		props: ['modelValue'],
		emits: ['update:modelValue'],
		methods: {
			toggle(){
				this.$emit('update:modelValue', !this.modelValue);
			}
		}
	}
</script>

<style scoped lang="scss">
	.toggle-icon{
		position: relative;
		width: 24px;
		height: 24px;
		cursor: pointer;
		
		span{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
	}
</style>
